import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { GroupPurchaseInfo } from 'frontend/types/premium/group-plans';

const groupPurchaseInfo: Module<GroupPurchaseInfo, RootState> = {
  namespaced: true,
  state: undefined,
  mutations: {
    setValue(state: GroupPurchaseInfo | undefined, value: GroupPurchaseInfo) {
      Object.assign(state, value);
    },
  },
};

export default groupPurchaseInfo;
